import { Action } from '@ngrx/store';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { DownloadReasonsReportRequest, LoadSummaryRequest, LoadSummaryResponse, DownloadSummarySearchRequest, PagingSorting } from '../../models';

export enum CreditReportActionTypes {
  ExecuteSearch = '[CreditReport] Execute Search',

  ProcessQueryString = '[CreditReport] Process Query String',

  NextPage = '[CreditReport] Next Page',
  PrevPage = '[CreditReport] Previous Page',
  SetPageSize = '[CreditReport] Set Page Size',
  LastPage = '[CreditReport] Last Page',
  FirstPage = '[CreditReport] First Page',
  SortBy = '[CreditReport] Sort By',

  LoadSummary = '[CreditReport] Summary',
  LoadSummarySuccess = '[CreditReport] Summary Success',
  LoadSummaryFailure = '[CreditReport] Summary Failure',

  DownloadReasonsReport = '[CreditReport] Download Reasons Report',
  DownloadReasonsReportSuccess = '[CreditReport] Download Reasons Report Success',
  DownloadReasonsReportFailure = '[CreditReport] Download Reasons Report Failure',

  DownloadRequestForm = '[CreditReport] Download Request Form',
  DownloadRequestFormSuccess = '[CreditReport] Download Request Form Success',
  DownloadRequestFormFailure = '[CreditReport] Download Request Form Failure',

  DownloadSummarySearch = '[CreditReport] Download Summary Search',
  DownloadSummarySearchSuccess = '[CreditReport] Download Summary Search Success',
  DownloadSummarySearchFailure = '[CreditReport] Download Summary Search Failure'
}

export class ProcessQueryString implements Action {
  readonly type = CreditReportActionTypes.ProcessQueryString;
  constructor(public payload: string) {}
}

export class NextPage implements Action {
  readonly type = CreditReportActionTypes.NextPage;
  constructor(public payload: LoadSummaryRequest, public pagingSorting: PagingSorting) {}
}

export class PrevPage implements Action {
  readonly type = CreditReportActionTypes.PrevPage;
  constructor(public payload: LoadSummaryRequest, public pagingSorting: PagingSorting) {}
}

export class SetPageSize implements Action {
  readonly type = CreditReportActionTypes.SetPageSize;
  constructor(public payload: number, public searchCriteria: LoadSummaryRequest) {}
}

export class LastPage implements Action {
  readonly type = CreditReportActionTypes.LastPage;
  constructor(public payload: LoadSummaryRequest, public pagingSorting: PagingSorting) {}
}

export class FirstPage implements Action {
  readonly type = CreditReportActionTypes.FirstPage;
  constructor(public payload: LoadSummaryRequest, public pagingSorting: PagingSorting) {}
}

export class SortBy implements Action {
  readonly type = CreditReportActionTypes.SortBy;
  constructor(public payload: string, public searchCriteria: LoadSummaryRequest, public pagingSorting: PagingSorting) {}
}

export class ExecuteCreditReportSearch implements Action {
  readonly type = CreditReportActionTypes.ExecuteSearch;
  constructor(public payload: LoadSummaryRequest) {}
}

export class DownloadReasonsReport implements Action {
  readonly type = CreditReportActionTypes.DownloadReasonsReport;
  constructor(public payload: DownloadReasonsReportRequest) {}
}

export class DownloadReasonsReportSuccess implements Action {
  readonly type = CreditReportActionTypes.DownloadReasonsReportSuccess;
  constructor(public payload: DownloadReasonsReportRequest) {}
}

export class DownloadReasonsReportFailure implements Action {
  readonly type = CreditReportActionTypes.DownloadReasonsReportFailure;
  constructor(public payload: any) {}
}

export class LoadSummary implements Action {
  readonly type = CreditReportActionTypes.LoadSummary;
  constructor(public payload: LoadSummaryRequest) {}
}

export class LoadSummarySuccess implements Action {
  readonly type = CreditReportActionTypes.LoadSummarySuccess;
  constructor(public payload: LoadSummaryResponse, public httpHeaders: HttpHeaders) {}
}

export class LoadSummaryFailure implements Action {
  readonly type = CreditReportActionTypes.LoadSummaryFailure;
  constructor(public payload: HttpErrorResponse | string) {}
}

export class DownloadRequestForm implements Action {
  readonly type = CreditReportActionTypes.DownloadRequestForm;
  constructor(public payload: { id: string }) {}
}

export class DownloadRequestFormSuccess implements Action {
  readonly type = CreditReportActionTypes.DownloadRequestFormSuccess;
  constructor(public payload: { id: string }) {}
}

export class DownloadRequestFormFailure implements Action {
  readonly type = CreditReportActionTypes.DownloadRequestFormFailure;
  constructor(public payload: { id: string; error: HttpErrorResponse | string }) {}
}

export class DownloadSummarySearch implements Action {
  readonly type = CreditReportActionTypes.DownloadSummarySearch;
  constructor(public payload: DownloadSummarySearchRequest) {}
}

export class DownloadSummarySearchSuccess implements Action {
  readonly type = CreditReportActionTypes.DownloadSummarySearchSuccess;
  constructor(public payload: DownloadSummarySearchRequest) {}
}

export class DownloadSummarySearchFailure implements Action {
  readonly type = CreditReportActionTypes.DownloadSummarySearchFailure;
  constructor(public payload: HttpErrorResponse | string) {}
}

export type CreditReportActions =
  | DownloadReasonsReport
  | DownloadReasonsReportFailure
  | DownloadReasonsReportSuccess
  | LoadSummary
  | LoadSummarySuccess
  | LoadSummaryFailure
  | DownloadSummarySearch
  | DownloadSummarySearchSuccess
  | DownloadSummarySearchFailure
  | DownloadRequestForm
  | DownloadRequestFormSuccess
  | DownloadRequestFormFailure
  | ExecuteCreditReportSearch
  | ProcessQueryString
  | NextPage
  | PrevPage
  | SetPageSize
  | LastPage
  | FirstPage
  | SortBy;
